import React from "react";
import "./quoteInvoiceEditModal.css";
import QuoteInvoiceEditPage from "./QuoteInvoiceEditPage";
import { useSnackbar } from "../../../../utils/GlobalSnackbar/GlobalSnackbarContext";
import BdrModal from "../../../../components/BdrModal/BdrModal";

const QuoteInvoiceEditModal = ({
  selectedObj,
  isInvoice,
  openBool,
  closeModal,
  returnNewObj,
}) => {
  const { handleSnack } = useSnackbar();

  return (
    <BdrModal
      open={openBool}
      onClose={closeModal}
      variant="panel"
      size="lg"
      /* the edit page renders its own header and close control */
      showHeader={false}
      ariaLabel={isInvoice ? "Edit invoice" : "Edit quote"}
    >
      <QuoteInvoiceEditPage
        selectedObj={selectedObj}
        isInvoice={isInvoice}
        handleSnack={handleSnack}
        returnNewObj={returnNewObj}
        closeModal={closeModal}
      />
    </BdrModal>
  );
};

export default QuoteInvoiceEditModal;
